<template>
    <svg id="Maps-Layers-Hunting" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            v-if="!state && !paint"
            d="M12.5 17.01a.59.59 0 0 1-.292-.084L.231 8.939a.51.51 0 0 1-.229-.427c0-.166.084-.333.23-.437L12.207.086a.52.52 0 0 1 .573 0l11.977 7.988c.146.094.23.26.23.437a.53.53 0 0 1-.23.438l-11.977 7.988a.478.478 0 0 1-.291.083l.01-.01zM1.46 8.51l11.04 7.364L23.54 8.51 12.5 1.148 1.46 8.511zM12.5 21.53a.589.589 0 0 1-.292-.084L.231 13.458a.519.519 0 0 1 .573-.864l11.686 7.79 11.685-7.79a.519.519 0 0 1 .573.864L12.77 21.446a.478.478 0 0 1-.292.084h.021zm.292 3.384 11.976-7.988a.52.52 0 0 0-.572-.864l-11.686 7.79-11.695-7.79a.519.519 0 0 0-.573.864l11.977 7.989a.478.478 0 0 0 .291.083.589.589 0 0 0 .292-.084h-.01zM16.406 7.73H13.28V4.606a.787.787 0 0 0-.781-.781.787.787 0 0 0-.781.78V7.73H8.594a.787.787 0 0 0-.78.781c0 .427.353.782.78.782h3.125v3.124c0 .427.354.781.781.781a.787.787 0 0 0 .781-.781V9.293h3.124a.787.787 0 0 0 .782-.782.787.787 0 0 0-.782-.78z"
        />

        <path
            v-if="state"
            d="M12 16.334c-.1 0-.19-.03-.28-.08L.222 8.588a.495.495 0 0 1-.22-.42c0-.17.08-.32.22-.42L11.72.082a.5.5 0 0 1 .55 0l11.498 7.666c.14.09.22.25.22.42 0 .17-.08.32-.22.42L12.27 16.254c-.08.06-.18.08-.28.08H12zm0 4.338c-.1 0-.19-.03-.28-.08L.222 12.926a.498.498 0 0 1 .55-.83l11.218 7.476 11.218-7.476a.498.498 0 0 1 .55.83L12.26 20.592a.46.46 0 0 1-.28.08H12zm.28 3.248 11.498-7.666a.498.498 0 0 0-.55-.83L12.01 22.901.792 15.425a.498.498 0 0 0-.55.829L11.74 23.92c.08.06.18.08.28.08.1 0 .19-.03.28-.08h-.02zm3.47-16.491h-3V4.43c0-.41-.34-.75-.75-.75s-.75.34-.75.75V7.43h-3c-.41 0-.75.34-.75.75 0 .409.34.749.75.749h3v2.998c0 .41.34.75.75.75s.75-.34.75-.75V8.928h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
        />
        <g v-if="paint" id="Painted">
            <path
                d="M12 20.668c-.1 0-.19-.03-.28-.08L.222 12.913a.499.499 0 0 1 .55-.83l11.218 7.484 11.218-7.485a.498.498 0 0 1 .55.83L12.26 20.589a.46.46 0 0 1-.28.08H12zm.28 3.252 11.498-7.675a.499.499 0 0 0-.55-.83L12.01 22.898.792 15.414a.498.498 0 0 0-.55.831L11.74 23.92c.08.06.18.08.28.08.1 0 .19-.03.28-.08h-.02z"
            />
            <path
                id="Body"
                d="M24 8.177v.999c0 .17-.08.32-.22.42l-11.5 7.664a.46.46 0 0 1-.28.08c-.1 0-.19-.03-.28-.08L.22 9.586a.495.495 0 0 1-.22-.42v-1c0-.17.08-.32.22-.42L11.72.083a.5.5 0 0 1 .55 0l11.5 7.665c.14.09.22.25.22.42l.01.01z"
                :fill="paint"
            />

            <path
                id="Paintme"
                d="M15.75 7.42h-3v-3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v3h-3c-.41 0-.75.34-.75.75s.34.75.75.75h3v3c0 .41.34.75.75.75s.75-.34.75-.75v-3h3c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z"
                fill="#fff"
            />

            <path
                id="Shadow"
                opacity=".4"
                d="m23.78 8.58-11.5 7.67a.46.46 0 0 1-.28.08c-.1 0-.19-.03-.28-.08L.22 8.58A.495.495 0 0 1 0 8.16v1c0 .17.08.32.22.42l11.5 7.67c.08.06.18.08.28.08.1 0 .19-.03.28-.08l11.5-7.67c.14-.09.22-.25.22-.42v-1c0 .17-.08.32-.22.42z"
                fill="#332E2E"
            />
        </g>
    </svg>
</template>

<script setup>
import { useState, stateProps } from '../../composables/useState';
import { usePaint, paintProps } from '../../composables/usePaint';

const props = defineProps({
    ...stateProps(),
    ...paintProps(),
});
const { state } = useState(props);
const { paint } = usePaint(props);
</script>
